import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileStack, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errorMessage } from "@/lib/api";

// "Copy an estimate": an outside estimate (PDF/JPG/PNG) becomes quote lines at the estimate's prices (1 credit).
export function CopyEstimateButton() {
  const navigate = useNavigate();
  const { company, setCredits } = useAuth();
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  const send = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/estimates", fd);
      setCredits(data.balance);
      navigate(`/quotes/new?extraction=${data.extraction_id}`);
    } catch (e) {
      if (e.response?.status === 402) setCredits(0);
      toast.error(errorMessage(e));
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };
  const empty = company && (company.credits ?? 0) <= 0;
  return (
    <>
      <button type="button" data-testid="copy-estimate-button" disabled={busy || empty} onClick={() => ref.current?.click()}
        title="Copy the items and prices of a finished estimate (1 credit, refunded if nothing is copied)"
        className="mt-5 mr-3 inline-flex items-center gap-2 rounded-full border border-slate-700 px-5 py-2.5 text-sm text-slate-300 transition-colors hover:border-amber-500/60 hover:text-[#171A20] disabled:opacity-40">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileStack className="h-4 w-4" />} Copy an estimate
      </button>
      <input ref={ref} type="file" accept=".pdf,.jpg,.jpeg,.png" className="hidden" data-testid="copy-estimate-file-input" onChange={(e) => send(e.target.files[0])} />
    </>
  );
}
